import { CalendarDayEvent } from '@gelatoas/design-editor-calendar';

import { MediaGridInfo } from 'editor/src/store/design/types';

// Bump when saved grid content may not match its settings: export redraws every grid whose
// stored hash differs, so old content is replaced on its next export.
const GRID_HASH_VERSION = 'v2';

const createGridHash = (gridInfo: MediaGridInfo, events: CalendarDayEvent[]) => {
  return [
    GRID_HASH_VERSION,
    gridInfo.designName,
    gridInfo.locale,
    gridInfo.firstDayOfWeek,
    gridInfo.hideWeekNum,
    gridInfo.gridDate.year,
    gridInfo.gridDate.month,
    JSON.stringify(events),
  ].join('-');
};

export default createGridHash;
